import { render, staticRenderFns } from "./PlayVideo.vue?vue&type=template&id=747f4ad6&scoped=true"
import script from "./PlayVideo.vue?vue&type=script&lang=js"
export * from "./PlayVideo.vue?vue&type=script&lang=js"
import style0 from "./PlayVideo.vue?vue&type=style&index=0&id=747f4ad6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747f4ad6",
  null
  
)

export default component.exports